import { booking, totalEarnings, totalWithdrawal } from '@assets/icons'
import DashboardCard from '@commons/cards/dashboard'
import Column from '@components/column'
import Tab from '@components/tabs'
import Title from '@components/title'
import React, { Fragment } from 'react'
import PlatformEarning from './platform-earning'
import WithdrawalRequest from './withdrawal-request'
import WithdrawalReleased from './withdrawal-released'
import WithdrawalRejected from './withdrawal-rejected'

const cardConfig = [
  {
    key: 'totalRevenue',
    title: 'Total Earnings',
    icon: totalEarnings,
    isUp: true,
    link: '/admin/transactions?tab=Platform%20Earnings',
  },
  {
    key: 'dailyActiveUser',
    title: 'Total Bookings Amount',
    icon: booking,
    isUp: true,
    // link: '/admin/game-management/match-rooms',
  },
  {
    key: 'totalMatchesCreatedByUser',
    title: 'Total Withdrawal Request',
    icon: totalWithdrawal,
    isUp: false,
    // link: '/admin/game-management/match-results?tab=Player Created',
  },
  {
    key: 'totalMatchesOnGoing',
    title: 'Total Withdrawal Released',
    icon: totalWithdrawal,
    isUp: false,
    // link: '/admin/game-management/match-results?tab=Admin Created',
  },
]
const items = [
  { label: 'Platform Earnings', component: PlatformEarning },
  { label: 'Withdrawal Request', component: WithdrawalRequest },
  { label: 'Withdrawal Released', component: WithdrawalReleased },
  { label: 'Withdrawal Rejected', component: WithdrawalRejected },
]
const Transaction = () => {
  return (
    <Fragment>
      <Column>
        <DashboardCard cardConfig={cardConfig} />
        <Title textone="Transactions" texttwo="Management" />
        <Tab items={items} />
      </Column>
    </Fragment>
  )
}

export default Transaction
